import CityPageTemplate from "../city-template/CityPageTemplate";
import { zanesvilleConfig } from "./data";

export default function ZanesvillePage() {
  return <CityPageTemplate config={zanesvilleConfig} />;
}